module.exports = [{"key":"environment-select","value":false},{"key":"workflow-terminate","value":true}]


//////////////////
// WEBPACK FOOTER
// ./client/feature-flags.json
// module id = 1457
// module chunks = 0